// @flow
import styled from "styled-components"
import { Text } from "componentsStyled/Typography/Texts"
import { Container } from "componentsStyled/Layout/Containers"
import { NavLink } from "componentsStyled/Typography"
import { mq, mqMax } from "common/mediaQuery"

export const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  margin-left: 0.5rem;
  font-size: inherit;
  font-weight: inherit;
  text-transform: lowercase;

  & + & {
    margin-left: 1rem;

    ${mq.tabletWide} {
      margin-left: 1rem;
    }
    ${mq.desktop} {
      margin-left: 1rem;
    }
    ${mqMax.tablet} {
      margin-left: 1rem;
    }
  }
`


export const StyledContainer = styled(Container)`
  padding-bottom: 0;
`

export const StyledText = styled(Text)`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 2rem;
`



// WEBPACK FOOTER //
// ./src/pages/AffiliateWelcome/styled.js